import { registerPanelForPanelRenderer } from '@databases/panel-types';
import { appStoreUtils } from '@databases/redux/store';
import React, { lazy, Suspense } from 'react';

import { dynamicImport } from '@canvas/dynamic-import';

const DatabaseSetupPanel = lazy(() =>
  dynamicImport(() => import('@databases/database-setup'))
);

const DuplicateStructurePanel = lazy(() =>
  dynamicImport(() => import('@databases/duplicate-database-panel/PanelContainer'))
);

const FieldSettingsPanel = lazy(() =>
  dynamicImport(() => import('@databases/frontend/FieldSettingsPanel'))
);

const DatabaseEntryPanel = lazy(() =>
  dynamicImport(() => import('@databases/frontend/DatabaseEntryPanel'))
);

const CreateFieldPanel = lazy(() =>
  dynamicImport(() => import('@databases/frontend/CreateFieldPanel'))
);

const DevtoolsPanel = lazy(() => dynamicImport(() => import('@databases/devtools')));

const ViewSettingsPanelDatabasesAdapter = lazy(() =>
  dynamicImport(() => import('@databases/frontend/ViewSettingsPanelDatabasesAdapter'))
);

export function registerPanelsForPanelRenderer() {
  registerPanelForPanelRenderer(
    'DatabaseSetupPanel',
    <Suspense>
      <DatabaseSetupPanel />
    </Suspense>
  );

  registerPanelForPanelRenderer(
    'DevtoolsPanel',
    <Suspense>
      <DevtoolsPanel appStoreUtils={appStoreUtils} />
    </Suspense>
  );

  registerPanelForPanelRenderer(
    'DuplicateStructurePanel',
    <Suspense>
      <DuplicateStructurePanel />
    </Suspense>
  );

  registerPanelForPanelRenderer(
    'FieldSettingsPanel',
    <Suspense>
      <FieldSettingsPanel />
    </Suspense>
  );

  registerPanelForPanelRenderer(
    'FieldCreatePanel',
    <Suspense>
      <CreateFieldPanel />
    </Suspense>
  );

  registerPanelForPanelRenderer(
    'ViewSettingsPanel',
    <Suspense>
      <ViewSettingsPanelDatabasesAdapter />
    </Suspense>
  );

  registerPanelForPanelRenderer(
    'EntryViewPanel',
    <Suspense>
      <DatabaseEntryPanel />
    </Suspense>
  );
}
